import { useState } from 'react'
import { FormDataset, mapToFormDataset } from '@confluent-cfet-medusa/dataset-designer'
import { DatasetConfig } from '../../types'
import { FormProvider, useForm } from 'react-hook-form'
import StreamToConfluentCloud from './StreamToConfluentCloud'
import MedusaRequestHandler from './MedusaRequestHandler'
import DatasetDesignerWrapper from './DatasetDesignerWrapper'
import Header from './header/Header'
import PageSection from './PageSection'
import { defaultEvents } from '../common/utils'
import { useSearchParams } from 'react-router-dom'
import Footer from './Footer'
import { theme } from '../common/themes'

const Home = () => {
  const [searchParams] = useSearchParams()
  const source = searchParams.get('source')
  const sourceIsTerrasnap = source === 'terrasnap'

  const [datasetConfig, setDatasetConfig] = useState<DatasetConfig>({
    dataset: {
      events: defaultEvents,
      tables: [],
    },
  })

  const [datasetDesignerFormData, setDatasetDesignerFormData] = useState<FormDataset>(
    mapToFormDataset({
      events: defaultEvents,
      tables: [],
    })
  )

  const methods = useForm({
    defaultValues: {
      producerConfig: {
        BOOTSTRAP_SERVERS: '',
        CLUSTER_API_KEY: '',
        CLUSTER_API_SECRET: '',
        SCHEMA_REGISTRY_URL: '',
        SCHEMA_REGISTRY_API_ID: '',
        SCHEMA_REGISTRY_API_SECRET: '',
        ADDITIONAL_PRODUCER_PROPERTIES: '',
      },
    },
  })

  return (
    <>
      <FormProvider {...methods}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: theme.background,
            paddingBottom: '75px',
          }}
        >
          <Header
            setDatasetDesignerFormData={setDatasetDesignerFormData}
            setDatasetConfig={setDatasetConfig}
            sourceIsTerrasnap={sourceIsTerrasnap}
          />

          <PageSection
            title="Mock Your Events"
            height="750px"
          >
            <DatasetDesignerWrapper
              setDatasetConfig={setDatasetConfig}
              datasetDesignerFormData={datasetDesignerFormData}
              setDatasetDesignerFormData={setDatasetDesignerFormData}
            />
          </PageSection>
          {sourceIsTerrasnap && (
            <PageSection
              title=""
              height="100%"
            >
              <MedusaRequestHandler
                datasetDesignerFormData={datasetDesignerFormData}
                setDatasetDesignerFormData={setDatasetDesignerFormData}
              />
            </PageSection>
          )}
          {!sourceIsTerrasnap && (
            <PageSection
              title="Stream to Confluent Cloud"
              height="100%"
            >
              <StreamToConfluentCloud datasetConfig={datasetConfig} />
            </PageSection>
          )}
        </div>
      </FormProvider>
      <Footer />
    </>
  )
}

export default Home
